import React, { useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";

const MoreOption = ({ row, options, openModal, OpenRetriggerModal }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  // setReassignPlan = useSetRecoilState(reassignPlan);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (item) => {
    if (item.label === "Re-run") {
      OpenRetriggerModal(row.jobId);
    } else if (item.label === "Download") {
      openModal(row.jobId);
    }
    setAnchorEl(null);

    item.actionState && item.actionState(true);
  };
  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        style={{ padding: 0, color: "#4183c5" }}
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        keepMounted
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{
          style: {
            padding: 0,
          },
        }}
        PaperProps={{
          style: {
            borderRadius: "10px",
          },
        }}
      >
        {options.map((item, i) => {
          return (
            <MenuItem
              key={i}
              onClick={() => handleAction(item)}
              style={{
                color: "#4183C5",
                borderBottom: "1px solid #E2E8F0",
                fontSize: "14px",
              }}
            >
              {item.image ? (
                <img
                  src={item.image}
                  style={{ paddingRight: "5px" }}
                  alt="more"
                />
              ) : null}
              <div></div>
              {item.label}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

export default MoreOption;
